import BackButtonToolbar from "features/BackButtonToolbar";
import { Create } from "react-admin";
import { settings } from "app";
import { tenants } from "utils/tenants";

import SaveForm from "./SaveForm";

const CreateScholarshipBudget = () => {
  const isMgu = settings.tenant === tenants.MGU;

  // MGU: budget is university-wide (no faculty). MU: budget is per faculty.
  const transform = ({ fiscalYear, amount, structuralUnitId }) =>
    isMgu
      ? { fiscalYear, amount, isUniversityWide: true }
      : { fiscalYear, amount, structuralUnitId, isUniversityWide: false };

  return (
    <Create
      title="Създаване на бюджет за стипендия"
      actions={<BackButtonToolbar />}
      transform={transform}
    >
      <SaveForm />
    </Create>
  );
};

export default CreateScholarshipBudget;
